import { useFootnoteOpenState } from '~/composables/footnotes/useFootnotesOpenSate'

/**
 * Composable for managing journal footnotes. Uses footnotes in the journal article fetched from Solr, and provides methods to open and close footnotes.
 *
 * @param footnotes - The footnotes in the journal article
 */
export function useJournalFootnotes(footnotes: MaybeRefOrGetter<{ footnoteId?: string, bodytext?: string }[] | undefined>) {
  const { openState, open, close } = useFootnoteOpenState()

  const { $parseStringToDocument } = useNuxtApp()

  return {
    open,
    close,
    data: computed(
      () => (toValue(footnotes) ?? []).reduce<FootnotesState>((acc, f) => {
        if (!f.footnoteId) {
          return acc
        }

        const isOpen = openState.get(f.footnoteId) ?? false

        acc[f.footnoteId] = {
          // Only open footnotes are inserted, and on the server every parse builds a jsdom document
          content: isOpen ? $parseStringToDocument(f.bodytext ?? '', ['create-journal-footnote-content']) : undefined,
          open: isOpen,
        }

        return acc
      }, {}),
    ),
  }
}
